
import React, { useState, useEffect } from 'react';
import api from '../api/api';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function AddInterruption() {
  const [form, setForm] = useState({
    id_application: '',
    id_nature: '',
    date_debut: '',
    date_fin: '',
    commentaire: '',
  });
  const [apps, setApps] = useState([]);
  const [natures, setNatures] = useState([]);
  const [error, setError] = useState(''); // 🔹 store validation error
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (!token) {
      navigate('/login');
      return;
    }

    const fetchData = async () => {
      try {
        const [appsRes, naturesRes] = await Promise.all([
          api.get('/applications', {
            headers: { Authorization: `Bearer ${token}` },
          }),
          api.get('/natures', {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        setApps(appsRes.data);
        setNatures(naturesRes.data);
      } catch (err) {
        console.error('Erreur chargement données:', err);
      }
    };

    fetchData();
  }, [navigate, token]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });

     // 🔹 Validate immediately when user edits date_fin
    if (name === 'date_fin' && form.date_debut && value < form.date_debut) {
      setError('La date de fin ne peut pas être antérieure à la date de début.');
    } else if (name === 'date_debut' && form.date_fin && form.date_fin < value) {
      setError('La date de début ne peut pas être postérieure à la date de fin.');
    } else {
      setError('');
    }
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    // 🔹 Double-check before sending to backend
    if (form.date_fin && form.date_fin < form.date_debut) {
      setError('La date de fin ne peut pas être antérieure à la date de début.');
      return;
    }
    try {
      await api.post('/interruptions', form, {
        headers: { Authorization: `Bearer ${token}` },
      });
      navigate('/dashboard');
    } catch {
      alert('Erreur : accès refusé ou données invalides');
    }
  };

  return (
    <>
      <Header />
      <main className="container">
        <h2>Nouvelle interruption</h2>
        <form onSubmit={handleSubmit}>
          <label>Application</label>
          <select
            name="id_application"
            value={form.id_application}
            onChange={handleChange}
            required
          >
            <option value="">-- Choisir une application --</option>
            {apps
              .filter((a) => a.actif) //  only active ones
              .map((a) => (
                <option key={a.id} value={a.id}>
                  {a.nom}
                </option>
              ))}
          </select>

          <label>Nature d’interruption</label>
          <select
            name="id_nature"
            value={form.id_nature}
            onChange={handleChange}
            required
          >
            <option value="">-- Choisir une nature --</option>
            {natures.map((n) => (
              <option key={n.id} value={n.id}>
                {n.libelle}
              </option>
            ))}
          </select>

          <label>Date de début</label>
          <input
            type="datetime-local"
            name="date_debut"
            value={form.date_debut}
            onChange={handleChange}
            required
          />

          <label>Date de fin</label>
          <input
            type="datetime-local"
            name="date_fin"
            value={form.date_fin}
            onChange={handleChange}
          />

          <label>Commentaire</label>
          <textarea
            name="commentaire"
            value={form.commentaire}
            onChange={handleChange}
            rows="3"
          />
            {/* 🔹 Show error message if invalid */}
          {error && <p className="error">{error}</p>}

          <button type="submit">Enregistrer</button>
        </form>
      </main>
      <Footer />
    </>
  );
}
